module.exports = __webpack_public_path__ + "static/media/Scikit_learn_logo_small.de1c5b33.svg";